export default {
  // Common
  brandName: 'SmartCrafter',
  github: 'GitHub',

  // Navigation
  nav: {
    features: 'Features',
    interface: 'Interface',
    workflow: 'Workflow',
  },

  // Hero
  hero: {
    badge: 'Structured Skills System',
    heading: 'Craft Your',
    headingHighlight: 'Knowledge',
    description: 'A desktop application for managing, organizing, and exporting structured knowledge modules with the precision of engineering and the artistry of craftsmanship.',
    exploreFeatures: 'Explore Features',
    viewOnGithub: 'View on GitHub',
  },

  // Features
  features: {
    sectionLabel: 'FEATURES',
    title: 'Built for Precision',
    description: 'Every feature is crafted to help you organize knowledge with the care and attention it deserves.',

    skillManagement: {
      title: 'Skill Management',
      description: 'Create, edit, and organize knowledge modules with hierarchical folder structures and rich metadata support.',
    },
    exportSystem: {
      title: 'Export System',
      description: 'Configure multiple export rules for different destinations with path-based filtering and orphan detection.',
    },
    importCapabilities: {
      title: 'Import Capabilities',
      description: 'Import skills from local file system directories to build your knowledge repository from existing content.',
    },
    markdownEditor: {
      title: 'Markdown Editor',
      description: 'Real-time markdown preview with syntax highlighting and a clean, distraction-free writing environment.',
    },
    threePanelInterface: {
      title: 'Three-Panel Interface',
      description: 'Efficient workflow with project tree, editor, and skill set panel working in perfect harmony.',
    },
    claudeIntegration: {
      title: 'Claude Integration',
      description: 'Seamlessly integrate with Claude AI for intelligent skill generation and management assistance.',
    },
  },

  // Interface Showcase
  interface: {
    sectionLabel: 'INTERFACE',
    title: 'A Workspace That Flows',
    description: 'The three-panel interface puts everything you need at your fingertips.',
    windowTitle: 'SmartCrafter',
    projectTree: 'PROJECT TREE',
    editor: 'EDITOR',
    skillSet: 'SKILL SET',
    realTimePreview: 'Real-time Preview',
    syntaxHighlighting: 'Syntax Highlighting',
  },

  // Workflow
  workflow: {
    sectionLabel: 'WORKFLOW',
    title: 'From Chaos to Clarity',
    description: 'A simple yet powerful workflow that transforms how you manage knowledge.',

    step1: {
      number: '01',
      title: 'Import or Create',
      description: 'Import existing skills from your file system or create new ones from scratch.',
    },
    step2: {
      number: '02',
      title: 'Organize & Structure',
      description: 'Arrange skills in hierarchical folders with rich metadata and categorization.',
    },
    step3: {
      number: '03',
      title: 'Export & Deploy',
      description: 'Configure export rules and deploy your skills to designated locations.',
    },

    useCaseLabel: 'USE CASE',
    aiSkillLibraries: {
      title: 'AI Skill Libraries',
      description: 'Build and maintain structured skill libraries for AI agents and assistants.',
    },
    documentationManagement: {
      title: 'Documentation Management',
      description: 'Organize project documentation with hierarchical structure and metadata.',
    },
  },

  // Footer
  footer: {
    copyright: '© 2025 SmartCrafter. Crafted with precision.',
  },

  // Language Switcher
  language: {
    en: 'EN',
    zh: '中文',
  },
}
